import React, { ButtonHTMLAttributes, HTMLProps } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Button } from '../../general/Button';

export const NextButton: React.FC<{nextPage: string, isDisabled?: boolean} & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'size'>
> = ({ nextPage, className, isDisabled = false}) => {
    const { t } = useTranslation('pension');
    const history = useHistory();
    return (
        <Button
            id="next"
            tint={'p-green'}
            size={'sm'}
            onClick={() => {
                history.push(nextPage);
            }}
            className={`${className} h-10 font-semibold px-8 ${isDisabled && 'opacity-50'}`}
            isDisabled={isDisabled}
            showWobbleArrow={true}
            wobbleArrowType={'right'}
        >
            {t('general-next')}
        </Button>
    );
};

export const BackButton: React.FC<HTMLProps<HTMLDivElement>> = ({ className }) => {
    const { t } = useTranslation('pension');
    const history = useHistory();
    return (
        <Button
            id="previous"
            tint="neutral-no-hover"
            size={'sm'}
            onClick={() => {
                history.goBack();
            }}
            className={`${className} h-10 px-8 font-semibold`}
            showWobbleArrow={true}
            wobbleArrowType={'left'}
        >
            {t('general-back')}
        </Button>
    );
};